import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function ComplexCases() {
  const tableData = [{
    item: '📘 CÓDIGO ALIMENTARIO (Producto Principal)',
    value: '$35.000'
  }, {
    item: '🎁 BONO #1: NEURO-PANTALLAS',
    value: '$15.000'
  }, {
    item: '🎁 BONO #2: RADAR ARFID PRO',
    value: '$15.000'
  }, {
    item: "🎁 BONO #3: FLASH PLANNER 5'",
    value: '$12.000'
  }, {
    item: '🎁 BONO #4: PARENT COACH PACK',
    value: '$12.000'
  }, {
    item: '🎁 BONO #5: MATRIZ DE EXPANSIÓN 360°',
    value: '$15.000'
  }];
  return <section className="bg-surface py-16 px-4 border-t border-border" data-id="element-34">
      <div className="max-w-4xl mx-auto" data-id="element-35">
        <div className="text-center mb-10" data-id="element-36">
          <h2 className="text-3xl md:text-4xl font-bold text-ink mb-3 font-serif" data-id="element-37">
            🎁 TODO LO QUE RECIBÍS HOY
          </h2>
        </div>

        <div className="overflow-x-auto mb-8 rounded-2xl border border-border shadow-md bg-white" data-id="element-38">
          <table className="w-full text-left border-collapse" data-id="element-39">
            <thead data-id="element-40">
              <tr className="bg-cream border-b border-border" data-id="element-41">
                <th className="p-5 text-ink font-bold w-2/3" data-id="element-42">Producto</th>
                <th className="p-5 font-bold w-1/3 text-ink text-right" data-id="element-43">
                  Valor
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border" data-id="element-44">
              {tableData.map((row, i) => <tr key={i} className="hover:bg-surface transition-colors" data-id="element-45">
                  <td className="p-5 text-ink font-medium" data-id="element-46">{row.item}</td>
                  <td className="p-5 text-muted text-right font-medium" data-id="element-47">
                    {row.value}
                  </td>
                </tr>)}
              <tr className="bg-surface" data-id="element-48">
                <td className="p-5 text-ink font-bold text-lg" data-id="element-49">
                  VALOR TOTAL REAL
                </td>
                <td className="p-5 text-urgency font-bold text-lg text-right line-through" data-id="element-50">
                  $104.000
                </td>
              </tr>
              <tr className="bg-primary-dark" data-id="element-51">
                <td className="p-6 text-gold font-bold text-xl md:text-2xl font-serif" data-id="element-52">
                  HOY PAGÁS SOLO
                </td>
                <td className="p-6 text-gold font-bold text-2xl md:text-3xl text-right font-serif" data-id="element-53">
                  $19.990
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>;
}